export const isMenuOpen = state => state.menu.isOpen



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/menu/menu.selectors.js